import {React} from 'common'
import RawButton from '@mui/material/Button'

const Button = ({children, onClick, variant, ...p}) => {
    return (
        <RawButton onClick={onClick} variant={variant} {...p}>
            {children}
        </RawButton>
    )
}

export default Button
